import { render } from "./ReliefFamilyForm.vue?vue&type=template&id=06efdf23&scoped=true"
import script from "./ReliefFamilyForm.vue?vue&type=script&lang=js"
export * from "./ReliefFamilyForm.vue?vue&type=script&lang=js"

import "./ReliefFamilyForm.vue?vue&type=style&index=0&id=06efdf23&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06efdf23"]])

export default __exports__